export default {
  title: {
    cashManagement: '现金管理',
    pointsManagement: '积分管理',
    rechargeRecord: '充值记录'
  },
  menu: {
    cashManagement: '现金管理',
    pointsManagement: '积分管理'
  },
  label: {
    companyName: '公司',
    referralExpireDate: '推荐过期时间',
    balance: '余额',
    cashRechargeListTitle: '{companyName}现金充值记录',
    pointsRechargeListTitle: '{companyName}积分充值记录',
    purchaseDate: '购买日期',
    jobName: '职位',
    activity: '操作',
    cash: '现金',
    note: '备注',
    rechargeTitle: '充值',
    companyCashBalanceTitle: '{companyName}的现金余额: {balance}',
    companyPointsBalanceTitle: '{companyName}的积分余额: {balance}',
    rechargePoints: '点数',
    rechargeNotes: '备注'
  },
  btn: {
    recharge: '充值',
    viewRechargeRecord: '查看充值记录'
  },
  placeholder: {
    searchCompany: '通过公司名称搜索',
    rechargePoints: '加或者减的点数',
    rechargeNotes: '备注（可选）'
  },
  message: {
    rechargeNotice: '当符号为负号时，数值不能超过当前余额',
    rechargeSuccess: '充值成功',
    rechargeFail: '充值失败'
  },
  COMPANY_BALANCE_ACTIVITY: {
    PURCHASED: '购买积分',
    ALLOCATED: '已分配',
    POST_PAY: '分配付款',
    REFUND: '返还预付款余额',
    REDISTRIBUTION: '内部转账'
  }
}
